export const electronicFormTextObj = {
  fileFormat: '输出开料清单文件格式',
  isSmallFile: '导出小板图片文件',
  useCategoryFolder: '电子锯文件根据颜色、材质、板厚分不同表格',
  rooms_by_category: '电子锯文件根据房间分不同表格',
  fileName: '自定义开料清单',
  outputFileEncoding: '输出清单编码格式',
  acrossTexture: '横纹',
  verticalTexture: '竖纹',
  noneTexture: '无纹理',
  cellTabs: '生成单元格制表符',
  data_format_no_text: '生成非文本格式数据类型',
  genSimpleLabelBarcode: '生成简易格式标签条码',
  uniqueBarCode: '板件条码唯一',
  texture_reversed_len_width: '横纹板件长宽对调',
  robotic_arm_model: '机械臂模型',
  enable: '启用机械臂对接',
  auto_line_enable: '启用自动线对接',
  labelingMachine: '输出自动贴标文件',
  labelFormat: '贴标文件格式',
  labelingDodge: '贴标自动避让',
  labelingStartPosition: '工位起始点',
  xDatumSwap: '坐标基准对调-x轴对调',
  yDatumSwap: '坐标基准对调-y轴对调',
  labelXOffset: '贴标坐标偏移-X',
  labelYOffset: '贴标坐标偏移-Y',
}

export const electronicFormValueObj = {
  outputFileEncoding: {
    gbk: 'GBK',
    'utf-8-sig': 'UTF-8带BOM',
  },
  labelingStartPosition: {
    top_left: '左上角',
    top_right: '右上角',
    bottom_left: '左下角',
    bottom_right: '右下角',
  },
}
